module.exports = __webpack_public_path__ + "414b0f631f57fb571d687b61ff1f30cd.svg";